export function isSamsungBrowser() {
  return /SamsungBrowser/i.test(navigator.userAgent);
}
